// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".digit-inputs input{width:inherit;text-align:center;height:70px;font-size:3em}.digit-inputs input.wrong{border-color:red !important}.digit-inputs input.valid{border-color:green !important}", ""]);
// Exports
module.exports = exports;
